const MAPY_CZ_URL = 'https://mapy.cz/';

/**
 * In order to use mapy.cz API attribution rules need to be followed
 *
 * @see https://developer.mapy.cz/rest-api/atributovani/
 */
export const MapyCzLogo = () => {
    return (
        <a className="absolute bottom-1 left-2" href={MAPY_CZ_URL} rel="noreferrer" target="_blank">
            <img alt="Mapy.cz logo" className="h-[28px]" src="/public/frontend/images/mapy-cz-logo-rgb.svg" />
        </a>
    );
};
